import Axios from 'axios'
import authplu from './auth'

const $ = Axios.create({
  timeout: 0,
  withCredentials: false
})

$.endWith = function(str, par) {
  const reg = new RegExp(par + '$')
  return reg.test(str)
}

// const serverUrl = window._CONFIG['serverUrl']
// const serverPortPre = window._CONFIG['serverPortPre']
// const appName = window._CONFIG['appName']
const serverUrl = process.env.VUE_APP_URL
console.log(process.env.VUE_APP_PORT)
const serverPortPre = process.env.VUE_APP_PORT
const appName = process.env.VUE_APP_APP_NAME

// const isLocalDev = process.env.NODE_ENV === 'development'

$.region = {
  api_basedata: `${serverUrl}:${serverPortPre}80`,
  clientapi_customer: `${serverUrl}:${serverPortPre}82`,
  clientapi_contacts: `${serverUrl}:${serverPortPre}82`,
  clientapi_brand: `${serverUrl}:${serverPortPre}83`,
  api_customers: `${serverUrl}:${serverPortPre}82`,
  api_goods: `${serverUrl}:${serverPortPre}83`,
  api_order: `${serverUrl}:${serverPortPre}84`,
  api_promotions: `${serverUrl}:${serverPortPre}85`,
  api_customer: `${serverUrl}:${serverPortPre}82`,
  api_coupon: `${serverUrl}:${serverPortPre}88`,
  api_admin: `${serverUrl}:${appName == 'yyy' ? '28099' : '28199'}`,
  api_pay: `${serverUrl}:${serverPortPre}89`,
  api: `${serverUrl}:${serverPortPre}95`,
  api_logistics: `${serverUrl}:${serverPortPre}79`,
  api_appversionupdate: `${serverUrl}:${serverPortPre}80`,
  api_aftersale: `${serverUrl}:${serverPortPre}87`,
  api_Employees: `${serverUrl}:${serverPortPre}86`, // 业务端
  api_employeefield: `${serverUrl}:${serverPortPre}86`, // 业务端
  api_coupons: `${serverUrl}:${serverPortPre}88`
}
$.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 添加请求拦截器
$.interceptors.request.use(
  function(config) {
    let url = config.url
    if (url.indexOf('/') == 0) {
      url = url.substring(1)
    }
    const index = url.indexOf('/')
    const region = url.substring(0, index)
    config.baseURL = $.region[region]
    // 在发送请求之前做些什么
    const token = authplu.getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // 判断若是在线客服请求需修改请求头（鉴权）
    if (config.url.indexOf('openapis.7moor.com') > -1) {
      config.headers['Authorization'] = btoa(encodeURI(`T00000019002:${config.data._time}`))
    }
    config.retry = 3 // 重试次数
    config.retryDelay = 200 // 重试延时
    config.shouldRetry = () => true // 重试条件，默认只要是错误都需要重试
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
$.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    const { data } = response
    if (typeof data !== 'object') {
      throw '未知的数据错误！'
    }
    if (
      (data.Msg && data.Msg.indexOf('客户信息') != -1) ||
      (data.Msg && data.Msg.indexOf('数据关系处理失败') != -1)
    ) {
      setTimeout(() => {
        authplu.removeLoginDatas()
        // window.location.href = '/'
      }, 1000)
    }
    return data
  },
  function(err) {
    const { response } = err
    if (response) {
      // 对响应错误做点什么
      if (
        typeof response['status'] !== 'undefined' &&
        response['status'] == 401
      ) {
        setTimeout(() => {
          authplu.removeLoginDatas()
          // window.location.href = '/'
        }, 1000)
        return response.data
      }
    }
    // 自动重试
    const config = err.config
    if (config) {
      if (!config || !config.retry) return Promise.reject(err)

      if (!config.shouldRetry || typeof config.shouldRetry !== 'function') {
        return Promise.reject(err)
      }

      if (!config.shouldRetry(err)) {
        return Promise.reject(err)
      }

      // 设置重置次数，默认为0
      config.__retryCount = config.__retryCount || 0

      // 判断是否超过了重试次数
      if (config.__retryCount >= config.retry) {
        return Promise.reject(err)
      }

      // 重试次数自增
      config.__retryCount += 1

      // 延时处理
      const backoff = new Promise(function(resolve) {
        setTimeout(function() {
          resolve()
        }, config.retryDelay || 1)
      })

      // 重新发起axios请求
      return backoff.then(function() {
        // console.log(`API请求重试： ${config.__retryCount}，URL：${config.url}`);
        return $(config)
      })
    }
    return Promise.reject(err)
  }
)
$.apiPromis = function(url, data, method) {
  return new Promise((resolve, reject) => {
    // 这句话是套路,记住
    const par = {
      url: url,
      method: method,
      data: data,
      ret: ({ body }) => {
        // console.log(body);
        resolve(body) // 执行成功函数
      },
      err: ({ body }) => {
        // console.log(body);
        reject(body) // 执行失败函数
      }
    }
    const token = authplu.getToken()
    if (token) {
      par.headers = {
        Authorization: 'Bearer ' + token
      }
    }
    try {
      window.api.ajax(par)
      // console.log('end');
    } catch (err) {
      //
    }
  })
}

$.getAction = function(url, data) {
  //   if (url.indexOf('/') == 0) {
  //     url = url.substring(1);
  //   }
  //   let index = url.indexOf('/');
  //   let region = url.substring(0, index);
  //   let host = $.region[region];

  //   if (!$.endWith(host, '/'))
  //   {
  //     host = host + '/';
  //   }
  //   if (window.api)
  //     return $.apiPromis(host + url, data, 'get')
  //   else
  const nurl =
    url.indexOf('?') > 0
      ? `${url}&time=${new Date().getTime()}`
      : `${url}?time=${new Date().getTime()}`
  if (!$._go) {
    $._go = this._go
  }
  return $.get(nurl, {
    params: data
  })
}
$.postAction = function(url, data) {
  //   if (url.indexOf('/') == 0) {
  //     url = url.substring(1);
  //   }
  //   let index = url.indexOf('/');
  //   let region = url.substring(0, index);
  //   let host = $.region[region];

  //   if (!$.endWith(host, '/'))
  //   {
  //     host = host + '/';
  //   }
  //   if (window.api)
  //     return $.apiPromis(host + url, data, 'post')
  //   else
  if (!$._go) {
    $._go = this._go
  }
  return $.post(url, data)
}
$.putAction = function(url, data) {
  //   if (url.indexOf('/') == 0) {
  //     url = url.substring(1);
  //   }
  //   let index = url.indexOf('/');
  //   let region = url.substring(0, index);
  //   let host = $.region[region];

  //   if (!$.endWith(host, '/'))
  //   {
  //     host = host + '/';
  //   }
  //   if (window.api)
  //     return $.apiPromis(host + url, data, 'put')
  //   else
  if (!$._go) {
    $._go = this._go
  }
  return $.put(url, data)
}
$.deleteAction = function(url, data) {
  //   if (url.indexOf('/') == 0) {
  //     url = url.substring(1);
  //   }
  //   let index = url.indexOf('/');
  //   let region = url.substring(0, index);
  //   let host = $.region[region];

  //   if (!$.endWith(host, '/'))
  //   {
  //     host = host + '/';
  //   }
  //   if (window.api)
  //     return $.apiPromis(host + url, data, 'delete')
  //   else
  if (!$._go) {
    $._go = this._go
  }
  return $.delete(url, data)
}
const install = function(Vue) {
  Vue.prototype.$axios = $
  Vue.axios = $

  Vue.prototype.getAction = Vue.prototype.$getAction = $.getAction
  Vue.getAction = Vue.$getAction = $.getAction

  Vue.prototype.postAction = Vue.prototype.$postAction = $.postAction
  Vue.postAction = Vue.$postAction = $.postAction

  Vue.prototype.putAction = Vue.prototype.$putAction = $.putAction
  Vue.putAction = Vue.$putAction = $.putAction

  Vue.prototype.deleteAction = Vue.prototype.$deleteAction = $.deleteAction
  Vue.deleteAction = Vue.$deleteAction = $.deleteAction
}
export default {
  install
}
